// extracted by mini-css-extract-plugin
export default {"box":"siteholder_box__sw0VE","black":"siteholder_black__vfE9R","white":"siteholder_white__EXsVb"};